/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiGetTagDefinitionResponseFromJSON, StreemApiListTagDefinitionsResponseFromJSON, StreemApiSaveTagDefinitionResponseFromJSON, } from '../models';
/**
 *
 */
export class TagsApi extends runtime.BaseAPI {
    /**
     * Determine whether or not a tag definition exists
     * Get a Tag Definition
     */
    async getTagDefinitionRaw(requestParameters) {
        if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
            throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling getTagDefinition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/tags/{tag_name}`.replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetTagDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * Determine whether or not a tag definition exists
     * Get a Tag Definition
     */
    async getTagDefinition(tagName) {
        const response = await this.getTagDefinitionRaw({ tagName: tagName });
        return await response.value();
    }
    /**
     * Lists all available tag definitions
     * List All Tag Definitions
     */
    async listTagDefinitionsRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListTagDefinitionsResponseFromJSON(jsonValue));
    }
    /**
     * Lists all available tag definitions
     * List All Tag Definitions
     */
    async listTagDefinitions(pageSize, pageToken) {
        const response = await this.listTagDefinitionsRaw({ pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * Creates or updates an existing tag definition
     * Save a Tag Definition
     */
    async saveTagDefinitionRaw(requestParameters) {
        if (requestParameters.tagName === null || requestParameters.tagName === undefined) {
            throw new runtime.RequiredError('tagName', 'Required parameter requestParameters.tagName was null or undefined when calling saveTagDefinition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/tags/{tag_name}`.replace(`{${"tag_name"}}`, encodeURIComponent(String(requestParameters.tagName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiSaveTagDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * Creates or updates an existing tag definition
     * Save a Tag Definition
     */
    async saveTagDefinition(tagName) {
        const response = await this.saveTagDefinitionRaw({ tagName: tagName });
        return await response.value();
    }
}
//# sourceMappingURL=TagsApi.js.map